/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import can from 'can';
import BaseWidget from 'scripts/base-widget';
import 'components/video-detail/video-detail';

export const VideoFeed = BaseWidget.extend({
    init: function() {
        this.viewModel = {
            showFeed: this.options.showFeed,
            type: this.getNormalizedType(this.options.type),
            tabs: new can.List(this.options.tabs || []),
            videoCard:
                this.options.video && this.options.video.identifier
                    ? new can.Map(this.options.video)
                    : null,
            sponsor: this.options.sponsor ? this.options.sponsor : null,
            backgroundImage: this.options.backgroundImage
                ? this.options.backgroundImage
                : null,
        };
        this.view = can.stache(`
            <video-detail 
                {type}="type" 
                {tabs}="tabs" 
                {sponsor}="sponsor"
                {active-card}="videoCard"
                {background-image}="backgroundImage"
                {show-feed}="showFeed"
            />`);
        this._super();
    },

    getNormalizedType(type) {
        if (_.isString(type)) {
            type = type.replace(/^video\-/, '');

            if (type === 'features') {
                type = 'featured';
            }

            return type;
        }

        return '';
    },
});
